import editor from "./editor";
import commonHelpers from "common/plugins/issues/and_on_clause";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
